<div class="spinner">
  <div class="double-bounce1" [style.background-color]="color"></div>
  <div class="double-bounce2" [style.background-color]="color"></div>
</div>